import Axios from "axios";

export default {
    all() {
        return Axios.get(
            process.env.BARRAMUNDI + "inventory/category?perPage=250"
        ).then(response => response.data.response.resources);
    },
    addNewCategory(params) {
        return Axios.post(
            `${process.env.BARRAMUNDI}inventory/category`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    updateCategory(params) {
        return Axios.put(
            `${process.env.BARRAMUNDI}inventory/category/${params.id}`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    deleteCategory(categoryId) {
        return Axios.delete(
            `${process.env.BARRAMUNDI}inventory/category/${categoryId}`
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    }
};
